import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, from, iif, merge, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../core/auth.service';
import { Deployment } from '../core/interfaces/deployment';
import { User } from '../core/interfaces/user';
import versionJson from '../../assets/.info.json';
import { DeploymentObject, PatchUserObject, ToggleDeploymentObject } from 'api';
import { Codes } from 'admin-api';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(private authService: AuthService, private http: HttpClient) {}

  users$(): Observable<User[]> {
    const url = environment.API_URL + '/users';
    return this.http.get<User[]>(url);
  }

  patchUser$(username: string, body: PatchUserObject): Observable<User> {
    const url = environment.API_URL + '/users/' + username;
    return this.http.patch<User>(url, body);
  }

  deployments$(): Observable<DeploymentObject[]> {
    const url = environment.API_URL + '/deployments';
    return this.http.get<DeploymentObject[]>(url);
  }

  downloadAdminKey$(stackName: string): Observable<string> {
    const secretName = stackName + '-key';
    const url = environment.API_URL + '/secret?secretname=' + secretName + '&keytype=mspkey';
    return this.http.get<string>(url);
  }

  updateDeployment$(tenantid: string, deploymentid: string): Observable<string> {
    const url = environment.API_URL + '/tenants/' + tenantid + '/deployments/' + deploymentid;
    return this.http.patch<string>(url, {});
  }

  deleteDeployment$(tenantid: string, deploymentid: string): Observable<string> {
    const url = environment.API_URL + '/tenants/' + tenantid + '/deployments/' + deploymentid;
    return this.http.delete<string>(url);
  }
  toggleDeployment$(tenantid: string, deploymentid: string, action: string): Observable<ToggleDeploymentObject> {
    const url = environment.API_URL + '/tenants/' + tenantid + '/deployments/' + deploymentid + '/power';
    return this.http.patch(url, { action });
  }

  getCodes$(): Observable<Codes> {
    const url = environment.API_URL + '/codes';
    return this.http.get(url);
  }
  addCodes$(quantity: number): Observable<Codes> {
    const url = environment.API_URL + '/codes';
    return this.http.post(url, { quantity });
  }
  getVersionData$() {
    return of(versionJson);
  }
  getLaunchResources$(): Observable<any> {
    //!!Todo response status code: 500
    const url = environment.API_URL + '/admin/resources';
    return this.http.get(url);
  }
}
